<template>
  <div id="index">
    <!-- 头部 -->
    <!-- <Hezuo></Hezuo> -->
    <HeaderTop :headIndex="1" ref="header"></HeaderTop>

    <div v-if="idloading">
      <div class="spinner-box">
        <img src="@/assets/img/loadding_pc.gif" alt="">
      </div>
    </div>
    <div class="swperdiv" v-if="!idloading">

      <div class="banner banner_swiper swiper-container">

        <div class="swiper-wrapper">
          <div class="swiper_item swiper-slide" v-for="(liem, index) in banner_arr" :key="index"
            @click.stop="bannerFun(liem)" :style="{ backgroundImage: 'url(' + IMG_URL + liem.url + ')' }">
            <!-- <a class="a_have" @click.stop="bannerFun(liem)"></a> -->
            <div class="zhezao" @click.stop="bannerFun(liem)" v-if="liem.detail && liem.detail.length !== 0">
              <div class="zzzs" v-if="liem.type == 2">
                <h3><span v-if="liem.type == 2">【文章】</span> {{ liem.detail.title}}</h3>
                <div class="bannew_text">{{ liem.detail.summary }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination fenyeqrr"></div>
        <div class="swiper-button-prev" style="color: #db414e"></div>
        <div class="swiper-button-next" style="color: #db414e"></div>

      </div>
    </div>

    <div class="main" v-if="!idloading">
      <div class="content">
        <!-- 轮播 -->

        <!-- 直播回看 -->
        <div class="module">
          <div class="top">
            <div class="left">
              <img class="icon_left" src="@/assets/img/home/biaoti_hk.png" alt="" />
              <span class="icon_text">直播回看</span>
            </div>
            <div class="right flex flex_center">
              <span class="more" @click="zhi">更多</span>
              <img src="@/assets/img/home/icon_gd.png" alt="" />
            </div>
          </div>
          <div class="bot">
            <div class="video_li" v-for="liem, idx in live_arr" :key="idx" @click="details(liem)">
              <div class="video_cover">
                <img class="video_img" :src="liem.cover" alt="" />
              </div>
              <div class="video_li_title">
                <div class="title">{{ liem.name }}</div>
                <div class="sub_tilte">
                  {{ liem.doctor }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 文章 -->
        
        <div class="module article_box" >
          <div>
            <div class="left">
              <img class="icon_left" src="@/assets/img/home/biaoti_wz.png" alt="" />
              <span class="icon_text">文章</span>
            </div>
            <div class="flex flex_between flex_center mar_t_10">
              <span style="font-weight: 500">热门推文</span>
              <div class="right flex flex_center">
                <span class="more" @click="wen">更多</span>
                <img src="@/assets/img/home/icon_gd.png" alt="" />
              </div>
            </div>
          </div>
          <div class="bot">
            <div class="article_item" v-for="item, index in data_arr.article" :key="index"
              @click="new_details(item.news_id)">
              <div style="width: 266px; height: 180px; overflow: hidden">
                <img class="article_img" :src="
  item.video_image != ''
    ? item.video_image
    : 'http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/headimage/moren.jpg'
" alt="" />
              </div>
              <div class="art_text">
                <div class="flex flex_between top">
                  <div class=" overonea">
                    原创：{{ item.user }}
                  </div>
                  <div>{{ item.create_time.split(" ")[0] }}</div>
                </div>
                <div class="botsx">
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex_between flex_center mar_t_10" style="margin-top: 20px; margin-bottom: 0px">
            <span style="font-weight: 500">栏目</span>
            <div class="right flex flex_center">
              <span class="more" @click="wen">更多</span>
              <img src="@/assets/img/home/icon_gd.png" alt="" />
            </div>
          </div>
          <!-- 栏目 -->
          <div class="lm_box">
            <div class="lm_item" v-for="item, index in data_arr.newConf" :key="index">
              <!-- <div class="tag_box" @click="new_conf(item.id, item.title)"> -->
              <div class="tag_box11" @click="new_conf(item.id, item.title)">
                <div class="box12">
                  <img class="lm_img" :src="
  item.image
    ? item.image
    : 'http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/headimage/moren.jpg'
" />
                  <div class="box-content">
                    <h3 class="title">#{{ item.title }}</h3>
                    <!-- <span class="post">Web designer</span> -->
                  </div>
                </div>
                <div class="overhindn"></div>
                <p class="tag_text">#{{ item.title }}</p>
              </div>
              <div class="flex flex_between yuan" v-for="i, index in item.news" :key="index"
                @click="new_details(i.news_id)">
                <img class="lm_small_img" :src="i.video_image" alt="" />
                <div class="lm_right">
                  <p>
                    {{ i.title }}
                  </p>
                  <div class="flex flex_between  tops">
                    <div class=" overonea">
                      原创：{{ i.user }}
                    </div>
                    <div>{{ i.create_time.split(" ")[0] }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 视频 -->
        <div class="module">
          <div class="top">
            <div class="left">
              <img class="icon_left" src="@/assets/img/home/biaoti_sp.png" alt="" />
              <span class="icon_text">视频</span>
            </div>
            <div @click="videoopen" class="right flex flex_center">
              <span class="more">更多</span>
              <img src="@/assets/img/home/icon_gd.png" alt="" />
            </div>
          </div>
          <div class="video_content mar_t_10" style="margin-bottom: 0px">

            <div class="video_one" @click="openvediodetil(data_arr.video[0])" v-if="length >= 1">
              <img class="one_img" :src="data_arr.video[0].cover" alt="" />
              <img class="play_icon" src="@/assets/img/home/icon_bf.png" alt="" />
              <div class="overhindn2"></div>

              <p class="video_title">{{ data_arr.video[0].title }}</p>
            </div>
            <div class="video_two">
              <div @click="openvediodetil(data_arr.video[1])" class="top" v-if="length >= 2">
                <img class="two_img" :src="data_arr.video[1].cover" alt="" />
                <img class="play_icon" src="@/assets/img/home/icon_bf.png" alt="" />
                <div class="overhindn2"></div>

                <p class="video_title">{{ data_arr.video[1].title }}</p>
              </div>
              <div @click="openvediodetil(data_arr.video[2])" class="one" v-if="length >= 3">
                <img class="two_img" :src="data_arr.video[2].cover" alt="" />
                <img class="play_icon" src="@/assets/img/home/icon_bf.png" alt="" />
                <div class="overhindn2"></div>
                <p class="video_title">{{ data_arr.video[2].title }}</p>
              </div>
            </div>
            <div @click="openvediodetil(data_arr.video[3])" class="video_one" v-if="length >= 4">
              <img class="one_img" :src="data_arr.video[3].cover" alt="" />
              <img class="play_icon" src="@/assets/img/home/icon_bf.png" alt="" />
              <div class="overhindn2"></div>

              <p class="video_title">{{ data_arr.video[3].title }}</p>
            </div>
            <div class="video_four">
              <div class="cv" v-for="item in data_arr.videoConf" :key="item.id" @click="catevideo(item.id)">
                <img class="db" :src="
  item.image
    ? item.image
    : 'http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/headimage/moren.jpg'
" alt="" />
                <div class="overhindn2"></div>

                <p class="center">{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 条漫 -->
        <div class="module">
          <div class="top">
            <div class="left">
              <img class="icon_left" src="@/assets/img/home/biaoti_tm.png" alt="" />
              <span class="icon_text">条漫</span>
            </div>
            <!-- <div class="right flex flex_center">
              <span class="more">更多</span>
              <img src="@/assets/img/home/icon_gd.png" alt="" />
            </div> -->
          </div>
          <!-- 条漫content -->
          <div class="tm">
            <div class="tm_left" style="margin-top: 10px">
              <div class="tm_left_item" v-for="item, index in data_arr.picture" :key="index"
                @click="picturego(item.id)">
                <img class="tm_left_item_img" :src="item.image" alt="" />
                <div class="overimg"></div>
                <p class="left_item_title">{{ item.title }}</p>
              </div>
            </div>
            <div class="tm_right">
              <div class="pic">
                <img src="@/assets/img/home/tupian_pt.png" alt="" />
              </div>
              <div class="box">
                <div class="box_text">
                  <p>扫码获取</p>
                  <p>知麻胡系列</p>
                  <p>表情包</p>
                  <p><img id="tu" src="@/assets/img/you.png" alt="" /></p>
                </div>
                <div class="mar_l_10">
                  <img src="@/assets/img/home/tupian_ewm.png" alt="" />
                </div>
                <div class="mar_l_10">
                  <img src="@/assets/img/home/tupian_ewm02.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <commonFooter></commonFooter>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";
// import "@/assets/css/loadding.css";
import "@/assets/js/swiper.animate1.0.3.min.js";
// import "@/assets/css/animate.min.css";
import HeaderTop from "@/components/assembly/HeaderTop.vue"; //头部模块
import commonFooter from "@/components/assembly/Footer.vue"; //底部模块
import Hezuo from '@/components/tool/hezuo.vue'
// import func from 'vue-editor-bridge';
export default {
  components: {
    HeaderTop,
    commonFooter,
    Hezuo
  },
  metaInfo: {
    meta: [
      { name: "keywords", content: '首页' },
    ],
  },
  data() {
    return {
      IMG_URL: this.$IMG_URL,
      banner_arr: [], //背景图片
      live_arr: [], //直播数组
      page: 1, //翻页
      live: [], //直播列表
      list_arr: [], //列表数组
      is_more: true,
      recommended_index: 0, //导航 2推荐 3关注
      banner_text_show: false,
      data_arr: [], //文章 栏目 视频 条漫
      showModal:false,
      length: 0,
      video_one: {},
      idloading: true,
      //   完成弹出
      istijiao: false,
      seolist: {},
      keywords: "",
      ishezuo: false,
      heform: {
        name: "",
        concat: "",
        company: "",
        content: "",
        type: 1,
      },
    };
  },
  created() {
    this.idloading = true;
    this.getLive();
    this.playback();
    this.getList();
    this.getArt();
    this.getSeo()
    if (this.aa_isMosbile()) {
      // alert("手机端");
      this.$router.replace('/m_home');
    } else {
      // alert("pc端");
    }
  },
  metaInfo() {
    return {
      meta: [
        { name: "keywords", content: this.keywords },
      ],
    };
  },
  mounted() {
    if (this.GetRequest().code) {
      this.WX_LOGIN_BINDING();
    }
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.idloading = false;

    this.request();
    let _this = this
    setTimeout(() => {
      let arr = document.querySelectorAll('[data-swiper-slide-index="0"]')
      arr[1].addEventListener('click', function () {
        _this.bannerFun(_this.banner_arr[0])
        console.log(112121);
      }, false);
    }, 1000);

    if (this.USER() && this.USER() !== {}) {
      this.REFRESH_USER();
    }
    document.title = 'vision麻醉·眼界';
    // this.request();
    this.selectBox_index = 1;
  },
  activated() {
    this.idloading = true;
    this.getLive();
    this.playback();
    this.getList();
    this.getArt();
    this.getSeo()
    if (this.aa_isMosbile()) {
      // alert("手机端");
      this.$router.replace('/m_home');
    }

    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.idloading = false;

    // this.request();
    let _this = this
    setTimeout(() => {
      let arr = document.querySelectorAll('[data-swiper-slide-index="0"]')
      arr[1].addEventListener('click', function () {
        _this.bannerFun(_this.banner_arr[0])
        console.log(112121);
      }, false);
    }, 1000);

    if (this.USER() && this.USER() !== {}) {
      this.REFRESH_USER();
    }
    document.title = 'vision麻醉·眼界';
    this.request();
    this.selectBox_index = 1;
  },
  methods: {
    // seo 
    getSeo() {
      this.$get("seo").then((res) => {
        if (res.code == 200) {
          this.keywords = res.data[1];
        }
      });

    },
    // 条漫跳转
    picturego(id) {

      this.$router.push({
        path: "column",
        query: { id: id },
      });

    },
    //直播回放更多
    zhi() {
      this.$router.push({ name: "index", query: { selectBox_index: 2 } });
    },
    //文章和栏目更多
    wen() {
      if (this.USER().id == undefined) {
          this.$refs.header.prompt1Show();
          return false;
        }else{
          console.log(this.USER(),'check')
          if(this.USER().check_status != 1){
            this.$refs.header.prompt2Show();
            return false;
          }
        }
      this.$router.push({ name: "column" });
    },
    videoopen() {
      this.$router.push({ name: "vedioIndex" });
    },
    carouselScroll() {
      new Swiper(".swiper-container", {
        // var mySwiper = new Swiper(".swiper-container", {
        direction: "horizontal",
        // 改变swiper样式时，自动初始化swiper
        observer: true,
        // 监测swiper父元素，如果有变化则初始化swiper
        observeParents: false,
        loop: true,
        autoplay: true,
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 20,
        // 如果需要分页器
        pagination: ".swiper-pagination",
      });
    },
    //获取文章和栏目
    getArt() {
      //获取录播列表
      let that = this;
      this.$get("index-data", {}).then((res) => {
        if (res.code == 200) {
          this.data_arr = res.data;
          this.length = res.data.video.length
        }
        //  
      });
    },
    getList() { },
    getLive() {
      //获取直播列表
    },
    playback() {
      //获取录播列表
      let that = this;
      this.$get("record_lists", { limit: 10, is_index: 1 }).then((res) => {
        that.live_arr = res.data;
      });
    },
    //文章详情
    new_details(id) {
       if (this.USER().id == undefined) {
          this.$refs.header.prompt1Show();
          return false;
        }else{
          console.log(this.USER(),'check')
          if(this.USER().check_status != 1){
            this.$refs.header.prompt2Show();
            return false;
          }
        }
      this.$router.push({
        name: "column_details",
        query: { id: id, head_index: 2 },
      });
    },
    openvediodetil(item) {
      this.$router.push({
        path: "/vedio_detil",
        query: { id: item.id, configid: item.video_conf_id },
      });
    },
    catevideo(id) {
      this.$router.push({
        path: "/vedio_list",
        query: { cateid: id },
      });
    },
    //文章栏目
    new_conf(id, title) {
      if(this.USER().check_status != 1){
            this.$refs.header.prompt2Show();
            return false;
          }
      this.$router.push({
        path: "column",
        query: { id: id },
      });
      //  
    },
    aa_isMosbile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    details(liem) {
      //跳转页面
      if (!this.is_judge(liem)) {
        return false;
      }
      let id = liem.id;
      let record_url = liem.record_url;
      let power = liem.power;
      if (this.aa_isMosbile()) {
        // alert("手机端");
        if (this.selectBox_index == 1) {
          //直播
          this.$router.push({
            path: "min_move",
            query: { id: id, url: record_url, power: power },
          });
        } else {
          this.$router.push({
            path: "min_record",
            query: { id: id, url: record_url, power: power },
          });
        }
      } else {
        // alert("pc端");
        if (this.selectBox_index == 1) {
          //直播
          this.$router.push({
            path: "pc_record",
            query: { id: id, url: record_url, power: power },
          });
        } else {
          this.$router.push({
            path: "pc_record",
            query: { id: id, url: record_url, power: power },
          });
        }
      }
    },
    bannerFun(liem) {
      //轮播跳转
      if (isNaN(liem.live_id)) {
        window.location.href = liem.live_id;
        return false;
      }
    
      if (!liem.detail && liem.type == 5) {
        // window.location.href = liem.href;
        window.open(liem.href)
        return;
      }

      if (this.aa_isMosbile()) {
        // alert("手机端");
        if (liem.type == 0) {
          if (!this.is_judge(liem)) {
            return false;
          }
          //直播
          this.$router.push({
            path: "min_move",
            query: {
              id: liem.live_id,
              url: liem.detail.live_url,
              power: liem.detail.power,
            },
          });
        } else {
          if (!this.is_judge(liem)) {
            return false;
          }
          this.$router.push({
            path: "min_record",
            query: {
              id: liem.live_id,
              url: liem.detail.live_url,
              power: liem.detail.power,
            },
          });
        }
      } else {
        // alert("pc端");
        if (liem.type == 1) {

          //直播
          if (!this.is_judge(liem)) {
            return false;
          }
          this.$router.push({
            path: "pc_move",
            query: {
              id: liem.live_id,
              url: liem.detail.live_url,
              power: liem.detail.power,
            },
          });
        } else if (liem.type == 2) {
            if (this.USER().id == undefined) {
              this.$refs.header.prompt1Show();
              return false;
            }else{
              if(this.USER().check_status != 1){
                this.$refs.header.prompt2Show();
                return false;
              }
            }
          //文章
          this.$router.push({
            path: "/column_details",
            query: { id: liem.news_id, head_index: 2 },
          });
        } else if (liem.type == 3) {


          this.$router.push({
            path: "/vedio_detil",
            query: { id: liem.video_id, configid: liem.detail.video_conf_id },
          });
          // 3视频
        } else if (liem.type == 4) {

          // 4会议
        }
        //  else {
        //   this.$router.push({
        //     path: "pc_record",
        //     query: { id: liem.live_id, url: liem.play_url, power: liem.power },
        //   });
        // }
      }
    },
    is_judge(liem) {
      //判断登录
      //  
      if (!liem.detail || !liem.detail.power) {
        //  
        if (liem.power == 0) {
          return true;
        }
        if (liem.detail.power == 0) {
          return true;
        }
      if (!this.USER() || this.USER().length == 0) {
          this.$refs.header.promptShow();
          // layer.open({
          //   content: "请先登录账号",
          //   time: true,
          //   skin: "msg"
          // });
          // setTimeout(()=>{
          //   this.$refs.header.registered(1);
          // },1000)

          return false;
        }

        
        // `power`  观看权限0全部，1会员，2超级会员',
        // `plus`  会员等级：0 = 普通用户 ，1 = 会员，2 = 超级会员',

        if (
          (this.USER().plus < 2 && liem.detail.power == 2) ||
          (this.USER().plus == 0 && liem.detail.power == 1)
        ) {
          layer.open({
            content: this.promptPermissions,
            time: true,
            skin: "msg",
          });
          return false;
        }
        return true;
      }
    },
    swiperFun() {
      //实例swiper
      new Swiper(".banner_swiper", {
        loop: true,
        // autoplay: true,
        // observer: true, //修改swiper自己或子元素时，自动初始化swiper
        // observeParents: true, //修改swiper的父元素时，自动初始化swiper
        //  simulateTouch : false,
        loopAdditionalSlides: 1,
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        spaceBetween: 20,
      });
    },
    request() {
      //获取banner
      let that = this;
      this.$get("banner_lists", { name: 2 }).then((res) => {
        that.banner_arr = res.data;
        that.$nextTick(function () {
          setTimeout(() => {
            that.swiperFun();
          }, 200);
        });
      });
    },
  },
};
</script>
<style >
/* .swiper-slide-active{
  width: 795px !important;
}
.swiper-slide-prev,.swiper-slide-next{
  width: 220px !important;
} */
</style>
<style scoped>
@keyframes spin {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(359deg);
  }
}

@keyframes configure-clockwise {
  0% {
    transform: rotate(0);
  }

  25% {
    transform: rotate(90deg);
  }

  50% {
    transform: rotate(180deg);
  }

  75% {
    transform: rotate(270deg);
  }

  100% {
    transform: rotate(359deg);
  }
}

@keyframes configure-xclockwise {
  0% {
    transform: rotate(45deg);
  }

  25% {
    transform: rotate(-45deg);
  }

  50% {
    transform: rotate(-135deg);
  }

  75% {
    transform: rotate(-215deg);
  }

  100% {
    transform: rotate(-305deg);
  }
}

@keyframes pulse {
  from {
    opacity: 1;
    transform: scale(1);
  }

  to {
    opacity: 0.25;
    transform: scale(0.75);
  }
}

/* GRID STYLING */

* {
  box-sizing: border-box;
}

body {
  min-height: 100vh;
  background-color: #37474f;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: flex-start;
}

.spinner-box {
  width: 100%;
  height: 90vh;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}

/* SPINNING CIRCLE */
.swiperhide1 {
  height: 100%;
  width: calc(18.5% - 20px);
  background-color: #88888870;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 9;
  border-radius: 10px;
}

.swiperhide2 {
  height: 100%;
  width: calc(18.5% - 20px);
  background-color: #88888870;
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 9;
  border-radius: 10px;
}

.circle-border {
  width: 150px;
  height: 150px;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: rgb(63, 249, 220);
  background: linear-gradient(0deg,
      rgba(63, 249, 220, 0.1) 33%,
      rgba(63, 249, 220, 1) 100%);
  animation: spin 0.8s linear 0s infinite;
}

.circle-core {
  width: 100%;
  height: 100%;
  background-color: #37474f;
  border-radius: 50%;
}

/* X-ROTATING BOXES */

.configure-border-1 {
  width: 115px;
  height: 115px;
  padding: 3px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffab91;
  animation: configure-clockwise 3s ease-in-out 0s infinite alternate;
}

.configure-border-2 {
  width: 115px;
  height: 115px;
  padding: 3px;
  left: -115px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(63, 249, 220);
  transform: rotate(45deg);
  animation: configure-xclockwise 3s ease-in-out 0s infinite alternate;
}

.configure-core {
  width: 100%;
  height: 100%;
  background-color: #37474f;
}

/* PULSE BUBBLES */

.pulse-container {
  width: 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pulse-bubble {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #3ff9dc;
}

.pulse-bubble-1 {
  animation: pulse 0.4s ease 0s infinite alternate;
}

.pulse-bubble-2 {
  animation: pulse 0.4s ease 0.2s infinite alternate;
}

.pulse-bubble-3 {
  animation: pulse 0.4s ease 0.4s infinite alternate;
}

/* SOLAR SYSTEM */

.solar-system {
  width: 250px;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.orbit {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ffffffa5;
  border-radius: 50%;
}

.earth-orbit {
  width: 165px;
  height: 165px;
  -webkit-animation: spin 12s linear 0s infinite;
}

.venus-orbit {
  width: 120px;
  height: 120px;
  -webkit-animation: spin 7.4s linear 0s infinite;
}

.mercury-orbit {
  width: 90px;
  height: 90px;
  -webkit-animation: spin 3s linear 0s infinite;
}

.planet {
  position: absolute;
  top: -5px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #3ff9dc;
}

.sun {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #ffab91;
}

.tag_box11:hover .tag_text {
  opacity: 0;
}

.box12 {
  font-family: "Merriweather Sans", sans-serif;
  overflow: hidden;
  position: relative;
  border-radius: 4px;
  z-index: 1;
  transition: all 0.5s;
}

.box12:hover {
  box-shadow: 3px 3px 5px #999;
}

.box12:before,
.box12:after {
  content: "";
  background: radial-gradient(circle at 23% 70%,
      rgba(255, 255, 255, 0.8),
      #fff 30%);
  width: 150%;
  height: 150%;
  opacity: 0;
  transform: rotate(45deg);
  position: absolute;
  top: -10.5%;
  right: -150%;
  z-index: 1;
  transition: all 0.35s ease;
}

.box12:after {
  background: rgba(255, 255, 255, 0.5);
  width: 65%;
  height: 65%;
  right: auto;
  left: -20%;
  top: -65%;
}

.box12:hover:before {
  opacity: 1;
  right: -85%;
}

.box12:hover:after {
  opacity: 1;
  top: -42%;
}

.box12 img {
  width: 100%;
  height: auto;
  transition: all 0.5s ease;
}

.box12:hover img {
  transform: scale(1.2);
}

.box12 .box-content {
  text-align: right;
  transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: -100%;
  z-index: 2;
  transition: all 0.5s;
}

.box12:hover .box-content {
  right: 5%;
}

.box12 .title {
  color: #1e272e;
  font-size: 23px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0 0 3px 0;
}

.box12 .post {
  font-size: 16px;
  text-transform: capitalize;
  margin: 0 0 10px;
  display: block;
}

.box12 .icon {
  padding: 0;
  margin: 0;
  list-style: none;
}

.box12 .icon li {
  display: inline-block;
  margin: 0 4px;
}

.box12 .icon li a {
  color: #fff;
  background-color: #1e272e;
  font-size: 18px;
  text-align: center;
  line-height: 35px;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  display: block;
  transition: all 0.3s;
}

.box12 .icon li a:hover {
  color: #1e272e;
  background-color: #fff;
  border-radius: 10%;
  box-shadow: 0 0 5px #1e272e inset;
}

@media only screen and (max-width: 990px) {
  .box12 {
    margin: 0 0 30px;
  }
}

@media only screen and (max-width: 479px) {
  .box12 .title {
    font-size: 20px;
  }
}

.botsx {
  font-size: 18px;
  font-weight: 500;
  margin: 7px 0px;
  display: -webkit-box;
  overflow: hidden;
  white-space: -webkit-nowrap;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.tm {
  margin-bottom: 80px;
  display: flex;
  justify-content: space-between;
}

.tm_right {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}

.pic {
  width: 343px;
  height: 355px;
  margin-bottom: -30px;
  position: relative;
  object-fit: cover;
}

.pic>img {
  width: 343px;
  height: 320px;
}
.box {
  width: 531px;
  height: 172px;
  display: flex;
  /* margin-bottom: 0px; */
  align-items: center;
  justify-content: space-evenly;
  box-shadow: 7px 0 46px rgba(71, 71, 71, 0.11);
  background: #fff;
  padding: 5px;
  border-radius: 4px;
  overflow: hidden;
  /* margin-top: 10px; */
}

.overhindn {
  position: absolute;
  /* z-index: 9; */
  width: 100%;
  top: 0px;
  left: 0;
  border-radius: 4px;
  height: 191px;
  background-image: linear-gradient(to top, #02020278 0%, #a6c1ee08 100%);
}

.overhindn2 {
  position: absolute;
  width: 100%;
  top: 0px;
  left: 0;
  height: 100%;
  background-image: linear-gradient(to top, #020202bf 0%, #a6c1ee08 70%);
}

/* .overhindn2:hover {
  position: absolute;
  width: 100%;
  top: 0px;
  left: 0;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
} */
.video_one:hover .one_img {
  transform: scale(1.2);
}

.video_one:hover .overhindn2 {
  background-color: rgba(0, 0, 0, 0.4);
}

.top:hover .two_img {
  transform: scale(1.2);
}

.one:hover .two_img {
  transform: scale(1.2);
}

.cv:hover .db {
  transform: scale(1.2);
}

.top:hover .overhindn2 {
  background-color: rgba(0, 0, 0, 0.4);
}

.one:hover .overhindn2 {
  background-color: rgba(0, 0, 0, 0.4);
}

.cv:hover .overhindn2 {
  background-color: rgba(0, 0, 0, 0.4);
}

.overimg {
  position: absolute;
  width: 100%;
  top: 0px;
  left: 0;
  height: 145px;
  background-image: linear-gradient(to left, #ffffff 40%, #a6c1ee0d 100%);
  transition: all 0.3s;
}

.tm_left_item:hover .overimg {
  opacity: 0;
}

.tm_left_item:hover .left_item_title {
  transform: translateY(-50%) translateX(200%);
}

.tm_left_item:hover .tm_left_item_img {
  transform: scale(1.3);
}

.box_text {
  text-align: center;
  font-size: 14.67px;
  color: #666;
}

.mar_l_10 {
  width: 157px;
  height: 157px;
  margin-left: 10px;
}

.mar_t_10 {
  margin-top: 40px;
  font-size: 24px;
  margin-bottom: -20px;
}

.mar_11 {
  font-size: 17px;
}

.tm_left_item {
  display: flex;
  box-shadow: 7px 0 46px rgba(71, 71, 71, 0.11);
  margin-top: 20px;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
}

.left_item_title {
  position: absolute;
  top: 50%;
  right: 50px;
  text-align: center;
  width: 30%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  transform: translateY(-50%);
  font-size: 21px;
  transition: all 0.3s;
}

.tm_left_item_img {
  width: 625px;
  height: 145px;
  object-fit: cover;
  transition: all 0.2s;
}

.video_content {
  display: flex;
  justify-content: space-between;
}

.video_one {
  width: 270px;
  height: 387px;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
}

.video_one .one_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.2s;
}

.video_title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  position: absolute;
  left: 50%;
  bottom: 43px;
  font-size: 19px;
  width: 238px;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  color: #fff;
}

.play_icon {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -40%);
  width: 54px;
  height: 54px;
}

.video_two {
  display: flex;
  width: 270px;
  height: 387px;
  flex-direction: column;
  justify-content: space-between;
}

.video_two .top {
  margin-top: 0 !important;
}

.two_img {
  width: 270px;
  height: 180px;
  transition: all 0.2s;
}

.video_two .top,
.one {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border-radius: 4px;
}

/* .video_two .video_title{
  bottom: 10px;
} */
.video_four {
  display: flex;
  width: 270px;
  height: 387px;
  flex-direction: column;
  justify-content: space-between;
}

.video_four img {
  object-fit: cover;
  /* height: 80px; */
}

/* 
.four_item{
  position: relative;
} */
.four_item .video_title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

body,
html {
  height: 100vh !important;
}

.main {
  max-width: 1280px;
  min-width: 865px;
  margin: 0 auto;
  /* width: 100%; */
  /* padding: 13px 0; */
  align-items: flex-start;
  position: relative;
}

.content {
  margin: 0 auto;

  width: 1190px;
}

#index {
  background: #f5f3fb;
  min-width: 1280px;
  width: 100%;
  background-image: url(http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/headimage/tupian_bg.jpg);
  background-size: 100% 100%;
}

.banner {
  height: 338px;
  max-width: 1280px;
  position: relative;
}

.swiper_item {
  position: relative;
  background-size: cover;
}

.zhezao {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  cursor: pointer;
  border-radius: 10px;
  /* background-color: rgba(0,0,0,.5); */
  /* background-image: linear-gradient(to top, #0000004d 0%, #ffffff00 100%); */
  background-image: linear-gradient(to top, #000000ba 0%, #ffffff00 59%);
}

.zzzs {
  position: absolute;
  bottom: 40px;
  left: 40px;
  width: 95%;
  color: #fff;
}

.zhezao h3 {
  font-weight: bold;
  font-size: 26px;
  letter-spacing: 1px;
}

.bannew_text {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 15px;
  padding-top: 10px;
  padding-left: 15px;
}

.banner_text {
  color: #ffffff;
  position: absolute;
  bottom: 0;
  left: 0;
}

/* .live{
    padding: 0 30px;
} */
.banner img {
  width: 100%;
}

.left {
  position: relative;
  margin-top: 20px;
}

.icon_left {
  width: 290px;
  height: 48px;
}

.icon_text {
  position: absolute;
  left: 104px;
  font-size: 24px;
  top: 10px;
  font-weight: bold;
  letter-spacing: 2px;
}

.module .top {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 20px;
}

.more {
  margin-right: 5px;
  /* font-weight: 700; */
  font-size: 17px;
  cursor: pointer;
}

.video_ul {
  flex-wrap: wrap;
  width: calc(100% + 40px);

  display: flex;
}

.article {
  flex-wrap: wrap;
  width: calc(100% + 40px);
  margin-left: 50%;
  transform: translateX(-50%);
  display: flex;
}

.video_cover {
  overflow: hidden;
}

/* .video_cover:hover>img{
  
} */
.video_cover>img {
  transition: all 0.2s;
  transform: scale(1);
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.swperdiv {
  width: 100%;
  position: relative;
  overflow: hidden;
  margin-top: 10px;
}

.overonea {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.video_cover>img:hover {
  transform: scale(1.2);
}

.article_img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  transition: all 0.2s;
  transform: scale(1);
}

.article_img:hover {
  transform: scale(1.2);
}

.art_text {
  padding: 0 10px;
  font-size: 12px;
}

.art_text .top {
  margin-top: 5px;
  color: #888888;
  font-size: 15px;
}

.art_text .bot {
  margin-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.article_item {
  /* background: #fff; */
  /* height: 200px; */
  width: 266px;
  border-radius: 4px;
  overflow: hidden;
  /* margin: 10px; */
  margin-bottom: 18px;
  padding-bottom: 6px;
  /* box-shadow: 7px 0 46px rgba(71, 71, 71, 0.11); */
  /* padding: 0 24px; */
  transition: all 0.5s ease;
  cursor: pointer;
  position: relative;
  transition: all 0.2s linear;
  transform-style: preserve-3d;
  /* min-width: calc(33% - 40px); */
}

.article_item:hover {
  box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
}

.video_li {
  display: flex;
  width: 385px;
  height: 293px;
  margin-bottom: 24px;
  border-radius: 4px;
  overflow: hidden;
  flex-direction: column;
  transition: all 0.2s linear;
  transform-style: preserve-3d;
  cursor: pointer;
}

.video_li:hover {
  box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
}

.video_ul .title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: bold;
}

.video_li_title {
  padding: 14px 13px 22px 22px;
  background-color: white;
}

.video_li_title .sub_title {
  margin-top: 5px;
}

.video_ul .video_li:hover {
  box-shadow: 7px 0 46px rgba(71, 71, 71, 0.32);
}

.lm_box {
  flex-wrap: wrap;
  width: calc(100% + 0px);
  margin-left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
}

.lm_item {
  width: 371px;
  height: fit-content;
  margin: 20px 0;
  border-radius: 10px;
  box-shadow: 7px 0 46px rgba(71, 71, 71, 0.11);
  /* padding: 0 24px; */
  transition: all 0.5s ease;
  cursor: pointer;
  position: relative;
}

.lm_box .lm_item .lm_img {
  width: 100%;
  height: 191px;
  object-fit: cover;
  opacity: 0.5;
  transition: all 0.2s linear;
  transform: scale(1);
}

.lm_box .lm_item .lm_img:hover {
  transform: scale(1.2);
  opacity: 1;
}

.tag_box {
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}

.tag_text {
  position: absolute;
  top: 150px;
  color: #ffffff;
  left: 50%;
  z-index: 9;
  letter-spacing: 2px;
  font-size: 20px;
  transform: translateX(-50%);
}

.lm_small_img {
  width: 132px;
  height: 90px;
  object-fit: cover;
  opacity: 1;
}

.yuan:hover .lm_small_img {
  opacity: 0.5;
}

.yuan:hover .lm_right {
  opacity: 0.5;
}

.lm_small_img:hover {
  opacity: 0.5;
}

.lm_right {
  opacity: 1;

  flex: 1;
  padding: 0px 18px;
  /* margin-left: 10px; */
  font-size: 10px;
  width: 69%;
}

.lm_right p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  height: 48px;
  -webkit-line-clamp: 2;
  letter-spacing: 0px;
  -webkit-box-orient: vertical;
  color: #484848;
  /* font-weight: bold; */
  font-size: 18px;
}

.bot {
  margin-top: 40px;
  /* height: 600px; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.bot_item {
  border-bottom: 2px solid #e5e6ea;
}

.title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  /* display: -webkit-box; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 18px;
  /* font-weight: bold; */
  margin-bottom: 5px;
}

.sub_tilte {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  /* display: -webkit-box; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  font-size: 15px;
  color: #888888;
}

.article {
  height: 450px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.yuan {
  background-color: white;
  height: 90px;
  /* border-bottom: 4px solid #e5e6ea; */
  margin-top: 5px;
  border-radius: 4px;
  overflow: hidden;
}

.lm_item .yuan:first-child {
  margin-top: 9px;
}

.tops {
  margin-top: 6px;
  margin-right: 10px;
  color: #8a8a8a;
  font-size: 13px;
}

.center {
  position: absolute;
  text-align: center;
  width: 100%;
  top: 40%;
  left: 50%;
  color: #fff;
  font-size: 25.67px;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}

.cv {
  cursor: pointer;
  position: relative;
  height: 109px;
  border: 1px solid gainsboro;
  border-radius: 4px;
  overflow: hidden;
}

.tm_left>div:nth-of-type(1) {
  margin-top: 30px;
}

#tu {
  width: 26px;
  height: 16px;
  margin-top: 10px;
}

/* 轮播 */
.swiper-container {
  width: 63%;
  height: 26.5vw;
  overflow: visible !important;
}

.swiper-container .swiper-wrapper .swiper-slide {
  width: 1160px;
  border-radius: 10px;
  filter: brightness(65%);
}

.swiper-container .swiper-wrapper .swiper-slide img {
  width: 100%;
  height: 320px;
  border-radius: 10px;
}

.swiper-container .swiper-wrapper .swiper-slide-prev {
  /* margin-top: 18px; */
  /* height: 560px !important; */
}

.swiper-container .swiper-wrapper .swiper-slide-prev img {
  height: 284px !important;
}

.swiper-container .swiper-wrapper .swiper-slide-next {
  /* margin-top: 18px; */
  /* height: 560px !important; */
}

.swiper-container .swiper-wrapper .swiper-slide-next img {
  height: 284px !important;
}

.swiper-container .swiper-wrapper .swiper-slide-active {
  width: 620px;
  filter: brightness(100%);
  position: relative;
  z-index: 9999;
}

.swiper-pagination {
  text-align: right;
  transform: translate3d(-50px, -21px, 0) !important;
}

/* #db414e */
.fenyeqrr /deep/ .swiper-pagination-bullet {
  border-radius: 24% !important;
  width: 15px !important;
  height: 4px !important;
  background: #ccc;
  opacity: 0.6;
}

.fenyeqrr /deep/ .swiper-pagination-bullet-active {
  background: #db414e;
  opacity: 1;
}

/* .swiper-pagination {
  bottom: -30px !important;
}
.swiper-pagination .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background: #ff1e1e;
}
.swiper-pagination .swiper-pagination-bullet-active {
  width: 21px;
  height: 12px;
  background: #e75230;
  border-radius: 6px;
} */
.db {
  height: 109px;
  width: 270px;
  transition: all 0.2s;
}

.hezuo {
  width: 100px;
  height: 100px;
  position: fixed;
  bottom: 180px;
  right: 20px;
  z-index: 99;
  cursor: pointer;
}

/* 视频分类弹出框 */
.popup_prompt {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9;
}

.prompt_div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
  width: 512px;
  height: 800px;
  border-radius: 10px;
  background: #f9f9f9;
}

.prompt_div .esc {
  width: 13.61px;
  height: 13.61px;
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
}

.prompt_div .title {
  width: 100%;
  display: flex;
  margin-top: 22px;
  margin-left: 16px;
  justify-content: center;
  align-items: center;
}

.prompt_div .title img {
  width: 67px;
  height: 67px;
  object-fit: cover;
  margin-right: 10px;
}

.prompt_div .title div {
  width: 67px;
  height: 67px;
  object-fit: cover;
}

.prompt_div .title span {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  opacity: 1;
}

.prompt_div .catelist {
  padding: 5.33vw 7.5vw;
  height: 63vw;
  overflow: scroll;
}

.prompt_div .cateitem {
  float: left;
  width: 33.33vw;
  height: 9.07vw;
  background: #ffffff;
  box-shadow: 0vw 1vw 1vw rgba(0, 0, 0, 0.05);
  opacity: 1;
  border-radius: 1vw;
  font-size: 3.2vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  opacity: 1;
  text-align: center;
  line-height: 9.07vw;
  margin-bottom: 4.5vw;
}

.activecate1 {
  background: #51a3ff !important;
  color: #fff !important;
}

.prompt_div .cateitem img {
  width: 2.98vw;
  height: 3.01vw;
}

.prompt_div .cateitem:nth-child(2n) {
  margin-left: 5.2vw;
}

.butok2 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 46px;
  border-radius: 0px 0px 4px 4px;
  background: #2a2a2a;
  text-align: center;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  opacity: 1;
}

/* 合作弹出 */
.text2 {
  width: 439px;
  font-size: 17px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  opacity: 1;
  margin: auto;
  /* text-align: center; */
}

.prompt_div .input1 {
  width: 449px;
  height: 41px;
  line-height: 41px;
  background: #ffffff;
  border: 1px solid #cccccc;
  opacity: 1;
  border-radius: 4px;
  margin: auto;
  margin-top: 12px;
  padding-left: 15px;
}

.prompt_div .input1 span {
  width: 70px;
  height: 18px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 27px;
  color: #999999;
  opacity: 1;
  padding: 0px 10px;
}

.prompt_div .input1 input {
  width: 65%;
}

.prompt_div .input2 {
  display: flex;
  width: 449px;
  height: 160px;
  background: #ffffff;
  border: 1px solid #cccccc;
  opacity: 1;
  border-radius: 4px;
  border-radius: 4px;
  margin: auto;
  margin-top: 15px;
}

.prompt_div .input2 textarea {
  width: 100%;
  height: 100%;
  border: 0;
  outline: 0;
  padding: 10px 0px;
}

.tijao4 {
  cursor: pointer;
  width: 415px;
  height: 35px;
  line-height: 35px;
  background: linear-gradient(90deg, #5eb1ff 0%, #0c57fe 100%);
  opacity: 1;
  border-radius: 20px;
  background: linear-gradient(90deg, #5eb1ff 0%, #0c57fe 100%);

  font-size: 18px;
  font-family: AdobeHeitiStd-Regular;
  color: #ffffff;
  opacity: 1;
  text-align: center;
  margin: auto;
  margin-top: 25px;
}

.qitahe {
  width: 449px;
  height: 130px;
  margin: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  margin-top: 50px;
}

.qitahe div {
  font-family: Source Han Sans CN;
}

.qitahe img {
  width: 129px;
  height: 129px;
  object-fit: cover;
}

.teq1 {
  height: 24px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  margin: auto;
  color: #333333;
  margin-bottom: 20px;
}

.teq2 {
  width: 215px;
  height: 19px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  margin: auto;
  color: #999999;
}

/* 提交成功 */
.tijiaook {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.tiji1 {
  margin-top: 77px;
  width: 63px;
  height: 63px;
  object-fit: cover;
}

.tiji2 {
  margin-top: 25px;
  width: 170px;
  height: 24px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 27px;
  color: #333333;
  opacity: 1;
}

.tiji3 {
  margin-top: 30px;
  width: 290px;
  height: 45px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 27px;
  color: #999999;
  opacity: 1;
}

.tiji4 {
  margin-top: 5px;
  width: 180px;
  height: 180px;
  object-fit: contain;
}

.swiper-container .swiper-button-prev {
  color: #fff !important;
  left: -292px;
  top: 5%;
  z-index: 99;
  width: 246px;
  height: 100%;
}

.swiper-container .swiper-button-prev::after {
  width: 25px;
  content: " ";
  height: 25px;
  border-bottom: 7px solid #fff;
  border-right: 7px solid #fff;
  border-radius: 5px;
  transform: rotateZ(-224deg);
  z-index: 99;
}

.swiper-container .swiper-button-next:after {
  width: 25px;
  z-index: 99;
  content: " ";
  height: 25px;
  border-bottom: 7px solid #fff;
  border-right: 7px solid #fff;
  border-radius: 5px;
  transform: rotateZ(-40deg);
}

.swiper-container .swiper-button-next {
  color: #fff !important;
  right: -292px;
  top: 5%;
  z-index: 99;
  width: 246px;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/pc_viwe/home.vue